import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";
import { EventType } from "../types";

interface StateType {
  data: EventType[];
  selected: EventType[];
  active: null | EventType;
  isLoading: boolean;
}

const initialState: StateType = {
  data: [],
  selected: [],
  active: null,
  isLoading: true,
};

export const eventsState = createSlice({
  name: "events",
  initialState,

  reducers: {
    setEvents: (state: StateType, action: PayloadAction<EventType[]>) => {
      state.data = action.payload;
    },
    setEventsSelected: (
      state: StateType,
      action: PayloadAction<EventType[]>
    ) => {
      const sortedEvents = action.payload
        .sort((a, b) => (a.bucketId || 0) - (b.bucketId || 0))
        .sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );
      state.selected = [...sortedEvents];
    },
    setEventsSelectedWithoutSort: (
      state: StateType,
      action: PayloadAction<EventType[]>
    ) => {
      state.selected = action.payload;
    },
    setEventActive: (
      state: StateType,
      action: PayloadAction<EventType | null>
    ) => {
      state.active = action.payload;
    },
    updateEventsSelected: (
      state: StateType,
      action: PayloadAction<EventType>
    ) => {
      const eventCode = action.payload.eventCode;
      const selected = state.selected;
      const isSelected = selected.some((itm) => itm.eventCode == eventCode);

      if (isSelected) {
        state.selected = selected
          .filter((itm) => itm.eventCode !== eventCode)
          .sort((a, b) => (a.bucketId || 0) - (b.bucketId || 0))
          .sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
          );
      } else {
        state.selected = [...selected, action.payload]
          .sort((a, b) => (a.bucketId || 0) - (b.bucketId || 0))
          .sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
          );
      }
    },
    updateEventsSelectedWithoutSort: (
      state: StateType,
      action: PayloadAction<EventType>
    ) => {
      const eventCode = action.payload.eventCode;
      const selected = state.selected;
      const isSelected = selected.some((itm) => itm.eventCode == eventCode);
      if (isSelected) {
        state.selected = selected
          .filter((itm) => itm.eventCode !== eventCode)
          .sort((a, b) => (a.bucketId || 0) - (b.bucketId || 0));
      } else {
        state.selected = [...selected, action.payload].sort(
          (a, b) => (a.bucketId || 0) - (b.bucketId || 0)
        );
      }
    },
    addSelectionMultiple: (
      state: StateType,
      action: PayloadAction<EventType[]>
    ) => {
      state.selected = [...state.selected, ...action.payload];
    },
    removeEvent: (state: StateType, action: PayloadAction<string>) => {
      const eventCode = action.payload;
      state.selected = state.selected.filter(
        (itm) => itm.eventCode !== eventCode
      );
    },
    removeEventMulti: (state: StateType, action: PayloadAction<string[]>) => {
      const eventCodes = action.payload;
      state.selected = state.selected.filter(
        (itm) => !eventCodes.includes(itm.eventCode)
      );
    },
    setIsLoading: (state: StateType, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearEventsSelected: (state: StateType) => {
      state.selected = [];
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.events;

export const selectEvents = createSelector(selector, (s) => s.data);
export const selectRegularEvents = createSelector(selector, (s) => {
  return s.data.filter((itm) => {
    return (
      !itm?.minEventSelectionRequired || itm?.minEventSelectionRequired == 0
    );
  });
});
export const selectEventsSelected = createSelector(selector, (s) => s.selected);
export const selectEventsSelectedById = (eventCode: string) => {
  return createSelector(selector, (state) => {
    return state.selected.find(
      (event) => event.eventCode === eventCode
    ) as EventType;
  });
};
// export const selectEventActive = createSelector(selector, (s) => s.active);
export const selectIsEventsLoading = createSelector(
  selector,
  (s) => s.isLoading
);
export const selectSpecialEventsSelected = createSelector(selector, (state) => {
  return state.selected.filter((itm) => {
    return itm?.minEventSelectionRequired && itm.minEventSelectionRequired > 0;
  });
});

export const selectRegularEventsSelected = createSelector(selector, (state) => {
  return state.selected.filter((itm) => {
    return (
      !itm?.minEventSelectionRequired || itm?.minEventSelectionRequired == 0
    );
  });
});

export const {
  setEvents,
  updateEventsSelected,
  updateEventsSelectedWithoutSort,
} = eventsState.actions;
export default eventsState.reducer;
